import * as React from "react";
import styled from "styled-components";
import Link from "../../elements/Link";
import { select } from "@hubper/theme";
import { PageSubtitle } from "../../typo";
import { Icon } from "../../elements";

const BackButtonBase = styled(Link)`
  display: flex;
  justify-content: flex-start;
  text-decoration: none;
  position: relative;
  padding-left: 13px;
  transition: ${select.speed("fast")};

  &:hover {
    color: ${select.color(["grey", 1])};
  }

  .icon {
    position: absolute;
    left: 0;
    top: 2px;
  }
`;

type BackButtonProps = {
  label: string;
  onClick?: () => void;
};

const BackButton = ({ onClick, label }: BackButtonProps) => {
  return (
    <BackButtonBase onClick={onClick}>
      <PageSubtitle>
        <Icon className="icon" size="12" c="inherit" name="left" />
        {label}
      </PageSubtitle>
    </BackButtonBase>
  );
};

export default BackButton;
